export enum Role {
  ContractManager = 'contract-manager'
}
